import { render, staticRenderFns } from "./PromoCodeAdmin.vue?vue&type=template&id=9164a680&scoped=true"
import script from "./PromoCodeAdmin.vue?vue&type=script&lang=js"
export * from "./PromoCodeAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9164a680",
  null
  
)

export default component.exports